import { MODAL_UPGRADE_PLAN } from '@components/App/Modal/constants'
import { Badge } from '@octopus-do/octopus-storybook'
import { openModal } from '@storeOld/reducers/ui'
import type React from 'react'
import { useDispatch } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import css from './styles.module.css'

export const UpgradeInfo: React.FC = () => {
  const dispatch = useDispatch()

  const handleClick = () => {
    sendGtmEvent(GtmTriggerName.UPGRADE_SEO)

    dispatch(
      openModal({
        modalType: MODAL_UPGRADE_PLAN,
        modalProps: {
          slideType: 'seo',
        },
      })
    )
  }

  return (
    <div className={css.upgrade_info} onClick={handleClick}>
      Upgrade to unlock SEO tags <Badge type="pro" size="default" />
    </div>
  )
}
